import React, { useState } from 'react'
import { useEffect } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { AutoComplete, Form, InputPicker, SelectPicker } from 'rsuite';
import { getAllCredentials, getCountries, getCredStatus, getCredStatusReason, getCredTypes } from '../../../services/Shared/codeTable.service';
import searchService from '../../../services/Internal/Search/search.service';
import EntitySearchGrid from './EntitySearchGrid';
import * as dayjs from 'dayjs';
import BlockUi from '@availity/block-ui';
import Swal from 'sweetalert2';
import PhoneNumberMask from '../../Shared/GenericComponents/PhoneNumberMask';


function EntitySearchPage() {
    const [searchModel, setSearchModel] = useState({
        lolaNumber: '',
        credentialNumber: '',
        credentialType: null,
        credentialStatus: null,
        credentialStatusReason: null,
        firstName: '',
        lastName: '',
        firmName: '',
        email: '',
        federalId: '',
        dateOfBirth: '',
        phone: '',
        stateProvince: '',
        postalCode: '',
        country: null,
        userId: '',
        nceesNumber: ''
    })
    const [countries, setCountries] = useState([])
    const [creds, setCreds] = useState();
    const [credType, setCredType] = useState([])
    const [credStaus, setCredStaus] = useState([])
    const [credReason, setCredReason] = useState([])
    const [gridData, setGridData] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [inputType, setInputType] = useState("text");


    useEffect(() => {
        getCountries().then(setCountries);
        getCredStatus().then(setCredStaus);
        getCredTypes().then(setCredType);
        const searchCache = JSON.parse(localStorage.getItem("searchCache"));
        if (searchCache) {
            if (searchCache.credentialStatus) {
                getCredStatusReason(searchCache.credentialStatus?.id).then(setCredReason);
            }
            setSearchModel(searchCache)
            cacheSearch(searchCache);
        }
    }, [])
    const cacheSearch = (searchCache) => {
        if (searchCache) {
            localStorage.removeItem("searchCache");
            var credentialNumber = null;
            var dateOfBirth = searchCache.dateOfBirth ? dayjs(searchCache.dateOfBirth).format('YYYY-MM-DD') : null;
            if (searchCache.credentialNumber?.includes("(") && searchCache.credentialNumber?.includes(")"))
                credentialNumber = searchCache.credentialNumber?.split("(")[1].split(")")[0];
            else if (searchCache.credentialNumber) {
                Swal.fire("Please select a credential from the credential autocomplete.");
                return false;
            }

            setIsSearching(true);
            var fedId = searchCache.federalId == '' ? null : searchCache.federalId
            localStorage.setItem("searchCache", JSON.stringify({ ...searchCache }));
            searchService.postEntitySearch({ ...searchCache, dateOfBirth: dateOfBirth, federalId: fedId, credentialNumber }).then((response) => {
                setGridData(response.data);

            })
        }
    }
    const feinSsnChange = (val) => {
        var newSearchModel = searchModel;
        var correctedText = val.replace(/[^\d-]*/g, "");
        newSearchModel.federalId = correctedText;
        setSearchModel({ ...newSearchModel });
    }
    const nceesChange = (val) => {
        var newSearchModel = searchModel;
        var correctedText = val.replace(/[^\d-]*/g, "");
        newSearchModel.nceesNumber = correctedText;
        setSearchModel({ ...newSearchModel });
    }
    const handleCredentialStatusChange = (val) => {
        setSearchModel({ ...searchModel, credentialStatus: val, credentialStatusReason: null })
        getCredStatusReason(val?.id).then(setCredReason);
    }
    const updateCreds = (value) => {
        getAllCredentials(value).then(setCreds);
    }
    const submitSearch = () => {
        var credentialNumber = null;
        var dateOfBirth = searchModel.dateOfBirth ? dayjs(searchModel.dateOfBirth).format('YYYY-MM-DD') : null;
        if (searchModel.credentialNumber?.includes("(") && searchModel.credentialNumber?.includes(")"))
            credentialNumber = searchModel.credentialNumber?.split("(")[1].split(")")[0];
        else if (searchModel.credentialNumber) {
            Swal.fire("Please select a credential from the credential autocomplete.");
            return false;
        }

        setIsSearching(true);
        var fedId = searchModel.federalId == '' ? null : searchModel.federalId
        localStorage.setItem("searchCache", JSON.stringify({ ...searchModel }));
        localStorage.setItem("currentPageCache", JSON.stringify(1));
        searchService.postEntitySearch({ ...searchModel, dateOfBirth: dateOfBirth, federalId: fedId, credentialNumber }).then((response) => {
            setGridData(response.data);
        })
    }
    const clearSearchModel = () => {
        setInputType("text");
        setSearchModel({
            lolaNumber: '',
            credentialNumber: '',
            credentialType: null,
            credentialStatus: null,
            credentialStatusReason: null,
            firstName: '',
            lastName: '',
            firmName: '',
            email: '',
            federalId: '',
            dateOfBirth: '',
            phone: '',
            stateProvince: '',
            postalCode: '',
            country: null,
            userId: '',
            nceesNumber: ''
        });
        localStorage.removeItem("searchCache");
    }
    return (
        <Container fluid>
            <h3 className="mb-3">Contact Search</h3>
            <Card className="mb-3">
                <Card.Header>
                    <h5>Search Criteria</h5>
                </Card.Header>
                <Card.Body>
                    <BlockUi blocking={isSearching}>
                        <Form fluid formValue={searchModel} onChange={setSearchModel} onSubmit={submitSearch} >
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>LOLA #</b></Form.ControlLabel>
                                        <Form.Control name="lolaNumber" placeholder="Enter LOLA #" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>First Name</b></Form.ControlLabel>
                                        <Form.Control name="firstName" placeholder="Enter Name" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Last Name</b></Form.ControlLabel>
                                        <Form.Control name="lastName" placeholder="Enter Name" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Organization Name</b></Form.ControlLabel>
                                        <Form.Control name="firmName" placeholder="Enter Name" />
                                    </Form.Group>
                                </Col>


                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Credential Type</b></Form.ControlLabel>
                                        <Form.Control
                                            name="credentialType"
                                            block
                                            data={credType}
                                            accepter={SelectPicker}
                                            searchable={false}
                                            placeholder="Select Type" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Credential #</b></Form.ControlLabel>
                                        <Form.Control
                                            accepter={AutoComplete}
                                            block
                                            data={creds}
                                            name="credentialNumber"
                                            placeholder="Credential #"
                                            onChange={updateCreds} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Credential Status</b></Form.ControlLabel>
                                        <Form.Control
                                            name="credentialStatus"
                                            block
                                            data={credStaus}
                                            accepter={SelectPicker}
                                            searchable={false}
                                            placeholder="Select Status"
                                            onChange={handleCredentialStatusChange} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Credential Status Reason</b></Form.ControlLabel>
                                        <Form.Control
                                            name="credentialStatusReason"
                                            block
                                            data={credReason}
                                            accepter={SelectPicker}
                                            searchable={false}
                                            readOnly={!searchModel.credentialStatus}
                                            placeholder="Select Status Reason" />
                                    </Form.Group>
                                </Col>


                            </Row>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Email</b></Form.ControlLabel>
                                        <Form.Control name="email" placeholder="Enter Email" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>SSN/FEIN</b></Form.ControlLabel>
                                        <Form.Control
                                            name="federalId"
                                            placeholder="Enter SSN/FEIN"
                                            type="text"
                                            onChange={feinSsnChange} />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Date of Birth</b></Form.ControlLabel>
                                        <Form.Control
                                            type={inputType}
                                            name="dateOfBirth"
                                            onFocus={() => setInputType("date")}
                                            onBlur={(e) => { if (!e.target.value) { setInputType("text") } }}
                                            placeholder="Date of Birth" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Phone</b></Form.ControlLabel>
                                        <Form.Control
                                            accepter={PhoneNumberMask}
                                            name="phone"
                                            format="(###) ###-####"
                                            mask="_"
                                            placeholder="Enter Phone" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col sm={3}>
                                    <Form.Group>
                                        <Form.ControlLabel><b>State/Province/Region</b></Form.ControlLabel>
                                        <Form.Control name="stateProvince" placeholder="State/Province/Region" />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Postal Code</b></Form.ControlLabel>
                                        <Form.Control name="postalCode" placeholder="Enter Postal Code" />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Country</b></Form.ControlLabel>
                                        <Form.Control
                                            block
                                            name="country"
                                            accepter={InputPicker}
                                            data={countries}
                                            placeholder="Select Country" />
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group>
                                        <Form.ControlLabel><b>User Id</b></Form.ControlLabel>
                                        <Form.Control name="userId" placeholder="Enter UserId" />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col sm={3}>
                                    <Form.Group>
                                        <Form.ControlLabel><b>NCEES</b></Form.ControlLabel>
                                        <Form.Control
                                            accepter={PhoneNumberMask}
                                            format="##-###-##"
                                            mask="_"
                                            name="nceesNumber"
                                            placeholder="NCEES ID#"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <hr />
                            <div style={{ textAlign: 'right' }}>
                                <Button onClick={clearSearchModel} variant="danger" className="me-2">Reset</Button>
                                <Button type="submit">Search</Button>
                            </div>
                        </Form>
                    </BlockUi>
                </Card.Body>
            </Card>

            <EntitySearchGrid gridData={gridData} setIsSearchingCallback={setIsSearching} />
        </Container>
    );
}

export default EntitySearchPage;